import React, { useState } from "react";
import { createPortal } from "react-dom";
import ReactTooltip from "react-tooltip";
import { consommation } from "./quotasOperateur";
import "../EP/jauge-remplissage-ep.scss";

// ============================================================
// Une consommation de quota (CE-1410) : l'anneau de remplissage des EP
// (`jauge-ep`) puis « utilisées / quota » en largeur fixe, pour que chaque
// case du tableau garde exactement la même composition. Sans quota, « 0 / 0 »
// et anneau vide. Ce qu'il reste s'affiche au survol, dans une infobulle
// immédiate (le `title` natif attend une seconde), et dans le libellé
// accessible. `grand` : la variante des totaux.
// ============================================================

let nbInstances = 0;
const RAYON = 100 / (2 * Math.PI);
const NIVEAU_JAUGE = { vide: "vide", normal: "normal", proche: "alerte", atteint: "complete" };

const ConsommationQuota = ({ utilisees, quota, grand = false }) => {
  const [tooltipId] = useState(() => `consommation-quota-${++nbInstances}`);
  const etat = consommation(utilisees, quota);
  return (
    <span
      className={`consommation-quota consommation-quota--${etat.niveau}${grand ? " consommation-quota--grand" : ""}`}
      role="img"
      aria-label={`${etat.utilisees} utilisées sur ${etat.quota}, ${etat.libelle}`}
      data-tip={etat.libelle}
      data-for={tooltipId}
    >
      <svg className={`jauge-ep jauge-ep--${NIVEAU_JAUGE[etat.niveau]}`} viewBox="0 0 36 36" focusable="false" aria-hidden="true">
        <circle className="jauge-ep__fond" cx="18" cy="18" r={RAYON} />
        <circle className="jauge-ep__remplissage" cx="18" cy="18" r={RAYON} strokeDasharray={`${etat.taux} 100`} />
      </svg>
      <span className="consommation-quota__valeur" aria-hidden="true">
        <b>{etat.utilisees}</b> / {etat.quota}
      </span>
      {createPortal(<ReactTooltip id={tooltipId} place="top" effect="solid" delayShow={0} />, document.body)}
    </span>
  );
};

export default ConsommationQuota;
